import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- ALL Video REVIEWS -------------------- */
export const AllVideoCollectionThunk = createAsyncThunk(
  "videocollection/AllVideoCollectionThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/product-video/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Video Collection"
      );
    }
  }
);

/* -------------------- GET SINGLE Video Collection -------------------- */
export const GetSingleVideoCollectionThunk = createAsyncThunk(
  "videocollection/GetSingleVideoCollectionThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/product-video/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch Video Collection details"
      );
    }
  }
);

/* -------------------- ADD Video Collection -------------------- */
export const AddVideoCollectionThunk = createAsyncThunk(
  "videocollection/AddVideoCollectionThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/product-video/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to add Video Collection"
      );
    }
  }
);

export const UpdateVideoCollectionThunk = createAsyncThunk(
  "videocollection/update",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/product-video/update", payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to update video");
    }
  }
);

/* -------------------- DELETE Video Collection -------------------- */
export const DeleteVideoCollectionThunk = createAsyncThunk(
  "videocollection/DeleteVideoCollectionThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/product-video/delete?uuid=${uuid}`
      );
      return {
        uuid,
        message:
          response.data?.message || "Video Collection deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to delete review");
    }
  }
);
